import { request } from '@/utils/request';

enum API {
  URL = '/system/menu',
}

/**
 * 获取分页数据
 * @param data - 请求数据
 */
export function getMenuPage(data: Partial<BaseFormData> & PaginationData) {
  return request.get<PageServerResult<BaseFormData[]>>(`${API.URL}/page`, { params: data });
}

/**
 * 根据ID获取数据
 * @param id - ID
 */
export function getMenuById(id: string) {
  return request.get<BaseFormData>(`${API.URL}/detail?id=${id}`);
}

/**
 * 新增数据
 * @param data - 请求数据
 */
export function createMenu(data: BaseFormData) {
  return request.post(`${API.URL}/create`, data);
}

/**
 * 修改数据
 * @param id - 修改id值
 * @param data - 请求数据
 */
export function updateMenu(id: string, data: BaseFormData) {
  return request.put(`${API.URL}/update/${id}`, data);
}

/**
 * 删除
 * @param id - 删除id值
 */
export function deleteMenu(id: string) {
  return request.delete(`${API.URL}/${id}`);
}

/**
 * 获取当前菜单数据
 * @param data - 请求数据
 */
export async function getMenuList(): Promise<{ code: number; data: SideMenu[] }> {
  // 从后端获取菜单树
  const menus: SideMenu[] = [
    {
      label: '仪表盘',
      labelEn: 'Dashboard',
      key: '/dashboard',
      rule: '/dashboard',
      icon: 'la:tachometer-alt',
    },
    {
      label: '内容管理',
      labelEn: 'Content Management',
      key: '/content',
      rule: '/content',
      icon: 'carbon:document',
      children: [
        { label: '首页配置', labelEn: 'Home Config', key: '/content/home', rule: '/content/home' },
        { label: '公司配置', labelEn: 'Company Config', key: '/content/company', rule: '/content/company' },
        { label: '应用行业配置', labelEn: 'Industry Config', key: '/content/industry', rule: '/content/industry' },
        { label: '产品配置', labelEn: 'Product Config', key: '/content/product', rule: '/content/product' },
        { label: '免费打样配置', labelEn: 'Free Sample Config', key: '/content/freeSample', rule: '/content/freeSample' },
        { label: '常见问题配置', labelEn: 'FAQ Config', key: '/content/faq', rule: '/content/faq' },
        { label: '文档下载配置', labelEn: 'Document Config', key: '/content/document', rule: '/content/document' },
        { label: '联系我们配置', labelEn: 'Contact Config', key: '/content/contact', rule: '/content/contact' },
      ],
    },
    {
      label: '系统管理',
      labelEn: 'System Management',
      key: '/system',
      rule: '/system',
      icon: 'ant-design:setting-outlined',
      children: [
        { label: '用户管理', labelEn: 'User Management', key: '/system/user', rule: '/authority/user/index' },
        { label: '菜单管理', labelEn: 'Menu Management', key: '/system/menu', rule: '/system/menu' },
        { label: '阿里云OSS管理', labelEn: 'Alibaba Cloud OSS Management', key: '/system/oss', rule: '/system/oss' },
      ],
    },
  ];
  return { code: 200, data: menus };
}

/**
 * 更改菜单状态
 * @param data - 请求数据
 */
export function changeMenuState(data: object) {
  return request.put(`${API.URL}/changeState`, data);
}

/** 获取菜单权限列表 */
export function getMenuPermissionList() {
  return request.get(`${API.URL}/permissionList`);
}
